import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { createFileRoute, Outlet, useMatch, useNavigate } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Flex } from '@/components/Flex'
import { Spinner } from '@/components/Spinner'
import { Tab, TabList, Tabs } from '@/components/Tabs'
import { useSharedPersistentState } from '@/hooks/useSharedPersistentState'

export const INGREDIENTS_BANNER = 'ingredient'
export const FCDB_INGREDIENTS_BANNER = 'fcdb-ingredient'

export const Route = createFileRoute('/ingredients')({
  component: IngredientsComponent,
  pendingComponent() {
    return <Spinner />
  },
})

function IngredientsComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const selectedView = useMatch({ from: '/ingredients/displaynames', shouldThrow: false })
    ? 'displaynames'
    : 'fcdb'
  const [, setIsIngredientBannerVisible] = useSharedPersistentState(INGREDIENTS_BANNER, true)
  const [, setIsFCDBIngBannerVisible] = useSharedPersistentState(FCDB_INGREDIENTS_BANNER, true)

  function showBanners() {
    setIsIngredientBannerVisible(true)
    setIsFCDBIngBannerVisible(true)
  }

  return (
    <>
      <Tabs
        selectedKey={selectedView}
        onSelectionChange={(key) => navigate({ to: `/ingredients/${key}` })}>
        <Flex style={{ alignItems: 'center' }}>
          <TabList aria-label="Ingredients" style={{ flexGrow: 1 }}>
            <Tab id="displaynames">{t('ingredient.ingredientGroups')}</Tab>
            <Tab id="fcdb">{t('ingredient.fcdbIngredients')}</Tab>
            <Tab id="Help" style={{ marginLeft: 'auto' }}></Tab>
          </TabList>
          <FontAwesomeIcon
            icon={faCircleQuestion}
            style={{ marginLeft: 'auto' }}
            onClick={() => showBanners()}
          />
        </Flex>
        <Outlet />
      </Tabs>
    </>
  )
}
